/**
 * These tokens were created to handle the cases where we cannot achieve the needed
 * styles witht the default mapping of old to rebranded tokens.
 * Tokens defined here should not declare exact values, they should only refer to
 * old tokens.
 */
// Checkbox tokens
export const checkboxCheckedHover = 'var(--goto-hover-primary)';
export const checkboxCheckedPressed = 'var(--goto-pressed-primary)';
// Badge tokens
export const badgeBackgroundDisabled = 'var(--goto-disabled-02)';
export const badgeIconDisabled = 'var(--goto-disabled-04)';
// Alert tokens
export const alertBackground = 'var(--goto-information-02)';
export const alertBorder = 'var(--goto-interactive-01)';
// Chip tokens
export const chipBackground = 'var(--goto-disabled-02)';
export const chipBackgroundSelected = 'var(--goto-interactive-01)';
export const chipBackgroundSelectedHover = 'var(--goto-hover-primary)';
export const chipBackgroundSelectedActive = 'var(--goto-pressed-primary)';
// SearchField tokens
export const searchFieldBackground = 'var(--goto-disabled-02)';
export const searchFieldBackgroundActive = 'transparent';
export const searchFieldBorderHover = 'var(--goto-disabled-02)';
export const searchFieldIconDisabled = 'var(--goto-text-03)';
export const searchFieldTextDisabled = 'var(--goto-text-01)';
export const searchFieldBackgroundDisabled = 'var(--goto-disabled-02)';
export const searchFieldOpacityDisabled = 'var(--disabled-opacity)';
export const searchFieldClearIconBackground = 'var(--goto-text-02)';
// Select tokens
export const selectInlineBorder = 'transparent';
export const selectInlineFont = 'var(--goto-caption-medium-strong)';
export const selectInlineBorderHover = 'var(--goto-field-01)';
export const selectInlineBackgroundHover = 'var(--goto-hover-secondary)';
export const selectInlineBorderActive = 'var(--goto-pressed-secondary)';
export const selectInlineBackgroundActive = 'var(--goto-pressed-secondary)';
// Round button tokens
export const roundButtonIconColor = 'var(--goto-icon-01)';
export const roundButtonBorderSuccess = 'var(--goto-success-01)';
export const roundButtonBorderDanger = 'var(--goto-danger-01)';
// Tabs tokens
export const tabsIndicatorBackground = 'var(--goto-interactive-01)';
// Skeleton tokens
export const skeletonGradient = 'linear-gradient(90deg, transparent, var(--goto-disabled-01), transparent)';
// Input tokens
export const inputSuccessBorder = 'var(--goto-success-01)';
export const inputDangerBorder = 'var(--goto-danger-01)';
// NavDrawer tokens
export const navDrawerItemBackgroundSelected = 'var(--goto-interactive-01)';
export const navDrawerItemIconColor = 'var(--goto-text-02)';
export const navDrawerItemIconColorSelected = 'var(--goto-text-04)';
// Avatar tokens
export const avatarBackgroundSecondaryDisabled = 'var(--goto-inverse-ui-05)';
export const avatarColorSecondaryDisabled = 'var(--goto-disabled-04)';
export const avatarBorderSecondaryDisabled = '1px solid var(--goto-disabled-04)';
// Popover tokens
export const popoverBorderColor = 'var(--goto-ui-02)';
export const popoverElevation = 'var(--goto-elevation-300)';
// Emptystate tokens
export const emptyStateIconColor = 'var(--goto-disabled-04)';
// RadioButton tokens
export const radioButtonBorderDisabled = 'var(--goto-border)';
// Menu tokens
export const menuBackground = 'inherit';
export const menuBackgroundHover = 'var(--goto-interactive-01)';
export const menuColorDisabled = 'var(--goto-text-03)';
export const menuColorHover = 'var(--goto-text-04)';
export const menuIconColor = 'var(--goto-text-02)';
export const menuElevation = 'none';
export const menuPresenceAvailableColor = 'var(--goto-text-04)';
export const menuPresenceBusyColor = 'var(--goto-text-04)';
export const menuPresenceAwayColor = 'var(--goto-text-04)';
export const menuPresenceDndColor = 'var(--goto-text-04)';
export const menuPresenceOfflineColor = 'var(--goto-text-04)';
// Button tokens
export const buttonNeutralInverseBorder = 'var(--goto-inverse-border)';
export const buttonNeutralInverseBackgroundHover = 'var(--goto-inverse-hover-01)';
export const buttonNeutralInverseBackgroundActive = 'var(--goto-inverse-pressed-01)';
// Snackbar tokens
export const snackbarContentColor = 'var(--goto-text-07)';
export const snackbarBackground = 'var(--goto-neutral)';
// Linear Progress tokens
export const progressBackgroundInverse = 'var(--goto-inverse-ui-05)';
// Switch tokens
export const switchBackgroundDisabled = 'var(--goto-disabled-02)';
export const switchCheckedBackgroundDisabled = 'var(--goto-disabled-02)';
export const switchKnobDisabled = 'var(--goto-disabled-04)';
// Tile tokens
export const tileBackground = 'var(--goto-interactive-01)';
export const tileBorder = 'var(--goto-interactive-01)';
export const tileBorderSecondary = 'var(--goto-interactive-01)';
export const tileBackgroundSelected = 'var(--goto-interactive-01)';
export const tileBackgroundHover = 'var(--goto-interactive-01)';
export const tileBackgroundActive = 'var(--goto-interactive-01)';
export const tileBackgroundSecondary = 'var(--goto-interactive-02)';
export const tileBackgroundSecondaryHover = 'var(--goto-hover-secondary)';
export const tileBackgroundSecondaryActive = 'var(--goto-pressed-secondary)';
export const tileBackgroundDisabled = 'var(--goto-ui-01)';
export const tileBorderDisabled = 'var(--goto-border)';
// Select tokens
export const optionBackgroundSelected = 'var(--goto-interactive-01)';
export const optionColorSelected = 'var(--goto-text-04)';
export const optionIconColorSelected = 'var(--goto-text-04)';
export const optionBackgroundHover = 'var(--goto-interactive-01)';
export const optionColorDisabled = 'var(--goto-disabled-04)';
export const optionIconColorDisabled = 'var(--goto-disabled-04)';
// Tooltip tokens
export const tooltipFont = 'var(--goto-caption-medium)';
